// Static data for the two Urban-Company-style customization flows.
// No API — these drive the SelectRequirementsModal and MakeYourOwnPackageModal.

export const HOME_CLEANING_CONFIG = {
  title: 'Furnished apartment — Home deep cleaning',
  meta: 'Starts at ₹3,499 · 5 hrs 55 mins',
  groups: [
    {
      id: 'size',
      title: 'Select size of apartment',
      type: 'single',
      options: [
        { id: '1bhk', label: '1 BHK', price: 3499 },
        { id: '2bhk', label: '2 BHK', price: 4299 },
        { id: '3bhk', label: '3 BHK', price: 4999 },
        { id: '4bhk', label: '4 BHK', price: 5799 },
      ],
    },
    {
      id: 'bathroom',
      title: 'Count of bathrooms',
      type: 'single',
      options: [
        { id: '1bath', label: '1 Bathroom', price: 0 },
        { id: '2bath', label: '2 Bathrooms', price: 299 },
        { id: '3bath', label: '3 Bathrooms', price: 598 },
        { id: '4bath', label: '4 Bathrooms', price: 897 },
      ],
    },
    {
      id: 'kitchen',
      title: 'Select kitchen cabinets & appliances',
      type: 'single',
      options: [
        { id: 'none', label: 'None', price: 0 },
        { id: 'cabinet', label: 'Cabinet interior with utensil arrangement', price: 399 },
        { id: 'chimney', label: 'Chimney cleaning', price: 499 },
        { id: 'both', label: 'Cabinet interior + Chimney', price: 799 },
      ],
    },
    {
      id: 'sofa',
      title: 'Select sofa & mattress',
      type: 'multi',
      items: [
        { id: 'dryvac', name: 'Dry vacuuming', price: 0 },
        { id: 'mattress', name: 'Mattress shampoo (per bed)', price: 439 },
        { id: 'sofa34', name: 'Sofa wet shampoo (3/4 seater)', price: 449 },
        { id: 'sofa56', name: 'Sofa wet shampoo (5/6 seater)', price: 649 },
      ],
    },
    {
      id: 'extra',
      title: 'Select extra room/area',
      type: 'multi',
      items: [
        { id: 'balcony', name: 'Balcony', price: 199 },
        { id: 'bathroom', name: 'Extra bathroom', price: 299 },
        { id: 'pooja', name: 'Pooja room', price: 149 },
        { id: 'store', name: 'Store room', price: 199 },
      ],
    },
  ],
};

// Focused single-question flow: "how many bathrooms to clean?" — shown as a
// radio popup on the specific bathroom-cleaning service detail page.
export const BATHROOM_CONFIG = {
  title: 'How many bathrooms to clean?',
  meta: 'Choose the number of bathrooms',
  groups: [
    {
      id: 'bathroom',
      title: 'Count of bathrooms',
      type: 'single',
      unit: 'bathroom',
      // price = what you pay, mrp = count × single-bathroom rate (drives the
      // "X% Off"), count drives the per-bathroom figure. Bulk = cheaper/unit.
      options: [
        { id: '1bath', label: '1 Bathroom',  price: 529,  mrp: 529,  count: 1 },
        { id: '2bath', label: '2 Bathrooms', price: 979,  mrp: 1058, count: 2 },
        { id: '3bath', label: '3 Bathrooms', price: 1399, mrp: 1587, count: 3 },
        { id: '4bath', label: '4 Bathrooms', price: 1799, mrp: 2116, count: 4 },
        { id: '5bath', label: '5 Bathrooms', price: 2199, mrp: 2645, count: 5 },
        { id: '6bath', label: '6 Bathrooms', price: 2599, mrp: 3174, count: 6 },
        { id: '7bath', label: '7 Bathrooms', price: 2999, mrp: 3703, count: 7 },
        { id: '8bath', label: '8 Bathrooms', price: 3399, mrp: 4232, count: 8 },
      ],
    },
  ],
};

// Urban-Company-style "Complete kitchen cleaning" requirements flow — cabinet
// cleaning + chimney/appliance add-ons + a visit-based plan (per-service price
// & bulk discount shown on each option).
export const KITCHEN_CONFIG = {
  title: 'Complete kitchen cleaning',
  meta: 'Starts at ₹999/service',
  groups: [
    {
      id: 'cabinet',
      title: 'Select cabinet cleaning',
      type: 'single',
      options: [
        { id: 'ext', label: 'Cabinet exterior only', price: 0 },
        { id: 'extint', label: 'Cabinet exterior + interior', price: 400 },
      ],
    },
    {
      id: 'appliances',
      title: 'Select chimney & other appliances',
      type: 'multi',
      items: [
        { id: 'chimney', name: 'Chimney cleaning', price: 500 },
        { id: 'fridge', name: 'Refrigerator cleaning', price: 300 },
        { id: 'microwave', name: 'Microwave cleaning', price: 200 },
        { id: 'stove', name: 'Gas stove / hob cleaning', price: 250 },
      ],
    },
  ],
};

// Beauty service-detail booking modal — pick a wax type (card + quantity).
// Shown when tapping "Book Now" on a Glam & Glow service.
export const BEAUTY_BOOKING = {
  ratingLabel: '4.89 (35K reviews)',
  variants: [
    { id: 'crystalgreen', name: 'Crystal green wax', price: 1249, rating: 4.89, reviews: '12K', badge: 'New',
      image: 'https://images.unsplash.com/photo-1519014816548-bf5fe059798b?w=300&h=300&fit=crop' },
    { id: 'ricagold', name: 'RICA gold', price: 1499, rating: 4.89, reviews: '12K',
      image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=300&h=300&fit=crop' },
    { id: 'moroccon', name: 'Moroccon honey', price: 1039, rating: 4.89, reviews: '11K',
      image: 'https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=300&h=300&fit=crop' },
    { id: 'chocolate', name: 'Chocolate wax', price: 1149, rating: 4.8, reviews: '9K',
      image: 'https://images.unsplash.com/photo-1522338242992-e1a54906a8da?w=300&h=300&fit=crop' },
    { id: 'ricacharcoal', name: 'RICA charcoal', price: 1099, rating: 4.85, reviews: '8K',
      image: 'https://images.unsplash.com/photo-1512496015851-a90fb38ba796?w=300&h=300&fit=crop' },
  ],
};

// Men's Care service-detail booking — pick a grooming option (card + quantity).
export const MENS_BOOKING = {
  ratingLabel: '4.85 (28K reviews)',
  variants: [
    { id: 'classiccut', name: 'Classic haircut', price: 299, rating: 4.86, reviews: '14K',
      image: 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=300&h=300&fit=crop' },
    { id: 'fadecut', name: 'Fade & style', price: 399, rating: 4.88, reviews: '12K', badge: 'New',
      image: 'https://images.unsplash.com/photo-1599351431202-1e0f0137899a?w=300&h=300&fit=crop' },
    { id: 'beardstyle', name: 'Beard styling', price: 199, rating: 4.82, reviews: '10K',
      image: 'https://images.unsplash.com/photo-1621607512214-68297480165e?w=300&h=300&fit=crop' },
    { id: 'haircolor', name: 'Hair colour', price: 899, rating: 4.8, reviews: '7K',
      image: 'https://images.unsplash.com/photo-1622286342621-4bd786c2447c?w=300&h=300&fit=crop' },
    { id: 'headmassage', name: 'Head massage', price: 349, rating: 4.84, reviews: '9K',
      image: 'https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=300&h=300&fit=crop' },
  ],
};

// Men's Care "make your own package" — grooming sections.
export const MENS_PACKAGE = {
  title: 'Make your own package',
  meta: 'Service time: 2 hrs',
  sections: [
    {
      id: 'haircut',
      title: 'Haircut & styling',
      optOut: "I don't need a haircut",
      items: [
        { id: 'classic', name: 'Classic haircut', price: 299, mrp: 374 },
        { id: 'fade', name: 'Fade & style', price: 399, mrp: 499 },
        { id: 'kids', name: 'Kids haircut', price: 249, mrp: 311 },
      ],
    },
    {
      id: 'beard',
      title: 'Beard & shave',
      optOut: "I don't need beard care",
      items: [
        { id: 'beardtrim', name: 'Beard trim & shape', price: 149, mrp: 186 },
        { id: 'royalshave', name: 'Royal shave', price: 249, mrp: 311 },
        { id: 'beardcolor', name: 'Beard colour', price: 399, mrp: 499 },
      ],
    },
    {
      id: 'grooming',
      title: 'Grooming & care',
      optOut: "I don't need grooming",
      items: [
        { id: 'facecleanup', name: 'Face cleanup', price: 499, mrp: 624 },
        { id: 'detan', name: 'De-tan (face & neck)', price: 599, mrp: 749 },
        { id: 'massage', name: 'Head & shoulder massage', price: 349, mrp: 436 },
      ],
    },
  ],
};

// Waxing wax-type variants (each item picks one; delta adjusts the price).
// delta is added to the item's base price to get that wax type's price.
const WAX_VARIANTS = [
  { id: 'ricaCharcoal',  label: 'RICA charcoal',          delta: 0 },
  { id: 'ricaGold',      label: 'RICA gold',              delta: 0 },
  { id: 'cirepilMojito', label: 'Cirepil mojito roll-on', delta: 230 },
  { id: 'crystalGreen',  label: 'Crystal green wax',      delta: -130 },
  { id: 'ricaGoldRoll',  label: 'RICA gold roll-on',      delta: 140 },
  { id: 'moroccan',      label: 'Moroccan honey',         delta: -220 },
];

export const BEAUTY_PACKAGE = {
  title: 'Make your own package',
  meta: 'Service time: 5 hrs',
  sections: [
    {
      id: 'waxing',
      title: 'Waxing',
      optOut: "I don't need waxing",
      variants: WAX_VARIANTS,
      items: [
        { id: 'fullarms', name: 'Full arms (including underarms)', price: 819, mrp: 1023, defaultVariant: 'ricaGold' },
        { id: 'fulllegs', name: 'Full legs', price: 769, mrp: 961, defaultVariant: 'ricaGold' },
        { id: 'back', name: 'Back', price: 669, mrp: 836, defaultVariant: 'ricaGold' },
        { id: 'stomach', name: 'Stomach', price: 619, mrp: 774, defaultVariant: 'ricaCharcoal' },
        { id: 'halflegs', name: 'Half legs', price: 349, mrp: 436, defaultVariant: 'moroccan' },
        { id: 'fullbody', name: 'Full body', price: 1799, mrp: 2249, defaultVariant: 'moroccan' },
        { id: 'underarms', name: 'Underarms', price: 99, mrp: 124, defaultVariant: 'moroccan' },
        { id: 'bikiniline', name: 'Bikini line', price: 499, mrp: 624, defaultVariant: 'moroccan' },
        { id: 'bikini', name: 'Bikini', price: 1099, mrp: 1374, defaultVariant: 'moroccan' },
      ],
    },
    {
      id: 'facial',
      title: 'Facial & cleanup',
      optOut: "I don't need facial",
      items: [
        { id: 'koreanglass', name: 'Korean glass skin facial', price: 2149, mrp: 2686 },
        { id: 'kglow', name: 'KGlow age rewind facial', price: 1899, mrp: 2374 },
        { id: 'koreanalgae', name: 'Korean sea algae facial', price: 2349, mrp: 2936 },
        { id: 'casmara', name: 'Casmara brightening facial', price: 3959, mrp: 4949 },
        { id: 'hydrafacial', name: 'Hydra glow facial', price: 2799, mrp: 3499 },
      ],
    },
    {
      id: 'cleanup',
      title: 'Cleanup',
      optOut: "I don't need cleanup",
      items: [
        { id: 'fruitcleanup', name: 'Fruit cleanup', price: 599, mrp: 749 },
        { id: 'insta', name: 'Insta glow cleanup', price: 799, mrp: 999 },
        { id: 'detan', name: 'De-tan cleanup', price: 899, mrp: 1124 },
      ],
    },
  ],
};
